import { render } from "./StudentRequirements.vue?vue&type=template&id=7bf52fb0"
import script from "./StudentRequirements.vue?vue&type=script&lang=js"
export * from "./StudentRequirements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__